import { gql } from '@apollo/client'

export const UPDATE_SHIUR_STATS = gql`
  mutation updateShiurStats($shiurId: String!, $duration: Float) {
    updateShiurStats(shiurId: $shiurId, duration: $duration)
  }
`
